export interface SocialWidgetService {
    name: string;
    type: string;
    placeholder: string;
    inputType?: string;
    pattern?: string;
}

export const SOCIALS_WIDGET_SERVICES: SocialWidgetService[] = [
    {
        name: 'Email',
        type: 'mail',
        placeholder: 'your@email.com',
        inputType: 'email',
    },
    {
        name: 'Facebook Url',
        type: 'facebook',
        placeholder: 'https://facebook.com/username',
        pattern: 'https://facebook.com/[a-zA-Z0-9._]+$',
        inputType: 'url',
    },
    {
        name: 'Twitter Handle',
        type: 'twitter',
        placeholder: '@yourtwitterhandle',
        pattern: '^@[A-Za-z0-9_]{1,15}$',
    },
    {
        name: 'Instagram Username',
        type: 'instagram',
        placeholder: '@instagramusername',
        pattern: '^@[a-zA-Z0-9._]+$',
    },
    {
        name: 'TikTok Username',
        type: 'tiktok',
        placeholder: '@tiktokusername',
        pattern: '^@[a-zA-Z0-9._]+$',
    },
    {
        name: 'Youtube Channel Url',
        type: 'youtube',
        placeholder: 'https://youtube.com/channel/youtubechannelurl',
        inputType: 'url',
        pattern: 'https://youtube.com/channel/[a-zA-Z0-9._]+$',
    },
    {
        name: 'SoundCloud Url',
        type: 'soundcloud',
        placeholder: 'https://soundcloud.com/username',
        inputType: 'url',
        pattern: 'https://soundcloud.com/[a-zA-Z0-9._]+$',
    },
    {
        name: 'Bandcamp Url',
        type: 'bandcamp',
        placeholder: 'https://you.bandcamp.com',
        inputType: 'url',
        pattern: 'https://[a-zA-Z0-9._]+.bandcamp.com$',
    },
    {
        name: 'LinkedIn Url',
        type: 'linkedin',
        placeholder: 'https://linkedin.com/in/username',
        inputType: 'url',
        pattern: 'https://linkedin.com/in/[a-zA-Z0-9._]+$',
    },
    {
        name: 'WhatsApp',
        type: 'whatsapp',
        placeholder: '+00000000000',
        pattern: '^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\\s\\./0-9]*$',
    },
    {
        name: 'Telegram Url',
        type: 'telegram',
        placeholder: 'https://t.me/',
        inputType: 'url',
        pattern: 'https://t.me/[a-zA-Z0-9._]+$',
    },
    {
        name: 'Twitch Url',
        type: 'twitch',
        placeholder: 'https://twitch.tv/username',
        inputType: 'url',
        pattern: 'https://twitch.tv/[a-zA-Z0-9._]+$',
    },
    {
        name: 'Patreon Url',
        type: 'patreon',
        placeholder: 'https://patreon.com/username',
        inputType: 'url',
        pattern: 'https://patreon.com/[a-zA-Z0-9._]+$',
    },
    {
        name: 'Pinterest Url',
        type: 'pinterest',
        placeholder: 'https://pinterest.com/',
        inputType: 'url',
        pattern: 'https://pinterest.com/.+',
    },
    {
        name: 'Spotify Artist Url',
        type: 'spotify',
        placeholder: 'https://open.spotify.com/artist/artistname',
        inputType: 'url',
        pattern: 'https://open.spotify.com/artist/[a-zA-Z0-9._]+$',
    },
    {
        name: 'Amazon Shop Url',
        type: 'amazon',
        placeholder: 'https://amazon.com/shop/yourshopname',
        inputType: 'url',
        pattern: 'https://amazon.com/shop/[a-zA-Z0-9._]+$',
    },
    {
        name: 'Snapchat Url',
        type: 'snapchat',
        placeholder: 'https://www.snapchat.com/add/yourusername',
        inputType: 'url',
        pattern: 'https://www.snapchat.com/add/[a-zA-Z0-9._]+$',
    },
    {
        name: 'Apple Music Url',
        type: 'apple',
        placeholder: 'https://music.apple.com/us/album/youralbum',
        inputType: 'url',
        pattern: 'https://music.apple.com/.+',
    },
];
